import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { IconButton, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateTodoOrder } from "api/all.api";
import "./todo.css";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  borderRadius: "0",
  color: "#000",
}));

export default function TodoDrag({ todos, handleUpdate, handleDelete }) {
  // const defaultList = ['A', 'B', 'C', 'D', 'E'];
  // React state to track order of items
  const [itemList, setItemList] = useState([]);
  const queryClient = useQueryClient();
  const orderMutation = useMutation({
    mutationFn: updateTodoOrder,
    onSuccess: (data, variables) => {
      if (data?.error) throw data.error;
      else {
        queryClient.setQueryData(["todos"], variables);
      }
    },
    onError: (err) => {
      console.log("Error : ", err);
    },
  });

  function compare(a, b) {
    if (a.num < b.num) {
      return -1;
    }
    if (a.num > b.num) {
      return 1;
    }
    return 0;
  }

  useEffect(() => {
    if (todos) setItemList(todos.sort(compare));
  }, [todos]);

  // Function to update list on drop
  const handleDrop = (droppedItem) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;
    var updatedList = [...itemList];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State

    updatedList = updatedList.map((li, key) => ({ ...li, num: key }));

    const data = updatedList;
    orderMutation.mutate(data);
    setItemList(updatedList);
  };

  return (
    <DragDropContext onDragEnd={handleDrop}>
      <Droppable droppableId="list-container">
        {(provided) => (
          <div
            className="list-container"
            {...provided.droppableProps}
            ref={provided.innerRef}>
            {itemList.map((item, index) => (
              <Draggable key={item._id} draggableId={item._id} index={index}>
                {(provided) => (
                  <Item
                    ref={provided.innerRef}
                    {...provided.dragHandleProps}
                    {...provided.draggableProps}
                    className="d-flex justify-content-between border">
                    <div className="col row">
                      <div className="col col-auto pr-1 pl-0">
                        {" "}
                        {item.isComplete ? (
                          <IconButton
                            onClick={() => handleUpdate(item._id, false)}
                            className="pt-0 pb-0"
                            size="small">
                            <RadioButtonCheckedIcon
                              // sx={{ fontSize: "20px" }}
                              color="success"
                              fontSize="small"
                              className="todo-icon-size"
                            />
                          </IconButton>
                        ) : (
                          <IconButton
                            onClick={() => handleUpdate(item._id, true)}
                            className="pt-0 pb-0"
                            size="small">
                            <RadioButtonUncheckedIcon
                              // sx={{ fontSize: "20px" }}
                              className="todo-icon-size"
                              fontSize="small"
                              color="success"
                            />
                          </IconButton>
                        )}
                      </div>
                      <div
                        className="col pl-1 pr-1"
                        style={{ paddingTop: "1px" }}>
                        <Typography
                          variant="p"
                          component="p"
                          sx={{
                            fontSize: "15px",
                            display: "inline",
                            // paddingTop: "5px",
                            textDecoration: `${
                              item.isComplete ? "line-through" : ""
                            }`,
                          }}>
                          {item.todo}
                        </Typography>
                      </div>
                    </div>
                    <div>
                      <IconButton
                        size="small"
                        className="pt-0"
                        onClick={() => handleDelete(item)}>
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </div>
                  </Item>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
